<template>
<div class="leaps-intention-list">
<div class="container-fluid" v-if="getLeapsIntentionList.length > 0">
  <div class="table-responsive margin-Top-6Perc" >
    <table class="table table-striped">
      <thead>
        <tr>
          <th class="text-align-center font-size-15px border-right">Intention Name</th>
          <th class="text-align-center font-size-15px border-right">Created TS</th>
          <th class="text-align-center font-size-15px border-right">Updated TS</th>
          <th class="text-align-center font-size-15px">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="currLeapsIntentionObj in getLeapsIntentionList" :key="currLeapsIntentionObj.IntentionLibraryId" :currLeapsIntentionObj="currLeapsIntentionObj">
          <td class="border-right text-align-center col-lg-4 col-md-4 border-right">{{currLeapsIntentionObj.IntentionTitle}}</td>
          <td class="text-align-center col-lg-2 col-md-2 border-right">{{formatAndShowDate(currLeapsIntentionObj.CreatedTS)}}</td>
          <td class="text-align-center col-lg-2 col-md-2 border-right">{{formatAndShowDate(currLeapsIntentionObj.UpdatedTS)}}</td>
          <td class="text-align-center col-lg-3 col-md-3">
            <a class="cursor-pointer" @click="performClickOperation($event,'edit', currLeapsIntentionObj)"> Edit </a>|
            <a class="cursor-pointer" @click="performClickOperation($event,'view', currLeapsIntentionObj)"> View </a>|
            <a class="cursor-pointer" @click="performClickOperation($event,'delete', currLeapsIntentionObj)"> Delete </a>
          </td>
        </tr>
      </tbody>
    </table>
    </div>
  </div>
  <update-leaps-intention-overlay v-if="openEditOverlay" :currSelectedObj="currSelectedObj" @emittedValue="updateEmittedValue"></update-leaps-intention-overlay>
  <view-leaps-intention-overlay v-if="openViewOverlay" :currSelectedObj="currSelectedObj" @emittedValue="updateEmittedValue"></view-leaps-intention-overlay>
  <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixString" v-bind:postfixString="postString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="deleteCurrentLeapsIntention"></confirmation-alert>
  <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
  <loader></loader>
</div>
</template>
<script>
import { leapsIntentionService } from '@/server-util/leaps-intention-service'
import UpdateLeapsIntentionOverlay from '@/components/leaps/intention/UpdateLeapsIntentionOverlay'
import ViewLeapsIntentionOverlay from '@/components/leaps/intention/ViewLeapsIntentionOverlay'
import AlertBox from '@/components/AlertOverlay'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import Loader from '@/components/dashboard/Loader'
import findIndex from 'lodash/findIndex'
export default {
  props: ['leapsIntentionList'],
  computed: {
    getLeapsIntentionList: {
      get: function () {
        return this.leapsIntentionList
      }
    }
  },
  data: function () {
    return {
      showAlertDialog: false,
      errorMsg: '',
      currSelectedObj: null,
      openEditOverlay: false,
      openViewOverlay: false,
      showConfirmationBox: false,
      prefixString: '',
      postString: ''
    }
  },
  name: 'leaps-intention-list',
  methods: {
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button confirmation overlay
      this.showConfirmationBox = value
      this.currSelectedObj = null
    },
    updateEmittedValue (recievedObj) {
      this.openEditOverlay = !recievedObj.closeOverlay
      this.openViewOverlay = !recievedObj.closeOverlay
      this.$store.state.isOverlayVisible = false
    },
    performClickOperation: function (event, operationName, selectedObj) {
      this.currSelectedObj = selectedObj
      switch (operationName) {
        case 'edit':
          this.openEditOverlay = true
          this.$store.state.isOverlayVisible = true
          break
        case 'view':
          this.openViewOverlay = true
          this.$store.state.isOverlayVisible = true
          break
        case 'delete':
          this.showConfirmationBox = true
          this.prefixString = 'Are you sure you want to delete '
          this.postString = '\'' + this.currSelectedObj.IntentionTitle + '\' intention?'
          break
      }
    },
    formatAndShowDate: function (date) {
      var dateToPass = date
      if (dateToPass.indexOf('Z') === -1) {
        dateToPass += 'Z'
      }
      return dmAdminUtils.covertUtcToEst(dateToPass)
    },
    deleteCurrentLeapsIntention (value) {
      this.showConfirmationBox = false
      if (value) {
        var storeObj = this.$store
        if (
          this.currSelectedObj.IntentionLibraryId !== undefined &&
          this.currSelectedObj.IntentionLibraryId !== null
        ) {
          this.$store.state.isLoading = true
          leapsIntentionService
            .deleteLeapsIntention(
              storeObj.state.access_token,
              this.currSelectedObj.IntentionLibraryId
            )
            .then(
              responseObj => {
                if (responseObj.status >= 200 && responseObj.status < 300) {
                  this.checkAndDeleteFromMasterLeapIntentionList()
                  this.$store.state.isLoading = false
                } else {
                  this.showAlertDialog = true
                  this.errorMsg =
                    'Oops! Something went wrong. Please try again.'
                  this.$store.state.isLoading = false
                }
              },
              errorObj => {
                this.$store.state.isLoading = false
                this.showAlertDialog = true
                this.errorMsg = errorObj.response.data.statusText
              }
            )
        } else {
          console.log(
            'IntentionLibraryId is NULL hence declined DELETE LEAP INTENTION Operation'
          )
        }
      }
    },
    checkAndDeleteFromMasterLeapIntentionList: function () {
      var foundIndex = findIndex(this.leapsIntentionList, (obj) => {
        return obj.IntentionLibraryId === this.currSelectedObj.IntentionLibraryId
      })
      // console.log('Delete Index: ' + foundIndex)
      if (foundIndex > -1) {
        this.leapsIntentionList.splice(foundIndex, 1)
      }
      foundIndex = findIndex(this.$store.state.leapsIntentionList, (obj) => {
        return obj.IntentionLibraryId === this.currSelectedObj.IntentionLibraryId
      })
      if (foundIndex > -1) {
        this.$store.state.leapsIntentionList.splice(foundIndex, 1)
      }
      this.$emit('updatedList', this.leapsIntentionList)
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    }
  },
  components: {
    'alert-box': AlertBox,
    'loader': Loader,
    'update-leaps-intention-overlay': UpdateLeapsIntentionOverlay,
    'view-leaps-intention-overlay': ViewLeapsIntentionOverlay,
    'confirmation-alert': ConfirmationOverlay
  }
}
</script>
<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.text-align-left {
  text-align: left;
}
.margin-Top-1Perc {
  margin-top: 1%;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.margin-Top-3Perc {
  margin-top: 3%;
}
.margin-Top-6Perc {
  margin-top: 6%;
}
.margin-left-1Perc {
  margin-left: 1%;
}
.margin-left-2Perc {
  margin-left: 2%;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.overflow-x-hidden {
  overflow-x: hidden !important;
}
.leaps-intention-list {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding-left: inherit;
  padding-right: inherit;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
.table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
}
.border-right {
  border-right: 1px solid #aaa !important;
}
.text-align-center {
  text-align: center !important;
}
.font-size-15px {
  font-size: 15px !important;
}
a:link {
  color: #2c3e50;
}
a:visited {
  color: #2c3e50;
}
a:hover {
  color: #2c3e50;
}
a:active {
  color: #2c3e50;
}
.btn-text-color {
  color: #2c3e50;
}
.cursor-pointer {
  cursor: pointer;
}
.text-decoration-underline {
  text-decoration: underline;
}
.table>thead>tr>th {
    vertical-align: bottom;
    border-bottom: 0px solid #aaaaaa;
}
.text-align-center{
  text-align: center !important;
}
a:link {
  color: #2c3e50;
}
a:visited {
  color: #2c3e50;
}
a:hover {
  color: #2c3e50;
}
a:active {
  color: #2c3e50;
}
.btn-text-color {
  color: #2c3e50;
}
a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a{
  color: #2c3e50 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/leaps/intention/LeapsIntentionList.vue